import { message } from "antd";
import axios from "axios";
import { create } from "zustand";

export const useCountries = create((set, get) => ({
    countries: [],
    ed: {},
    setEd: (v) => {
        set({ ed: v })
    },
    columns: [
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: 'O\'zbekcha nomi', dataIndex: 'nameuz', key: 'nameuz' },
        { title: 'Ruscha nomi', dataIndex: 'nameru', key: 'nameru' },
    ],
    getCountries: () => {
        axios.get('/countries').then(res => {
            set({ countries: res.data })
        }).catch(error => {
            message.error("Ma'lumotlarni olishda muammo yuzaga keldi!!!")
        })
    },
    deleteCountry: (id) => {
        axios.delete('/countries/' + id).then(res => {
            get().getCountries()
            message.success("Muvaffaqiyatli o'chirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'chirishda muammo yuzaga keldi!!!")
        })
    },
    updateCountry: (v) => {
        axios.put('/countries/' + v.id, v).then(res => {
            get().getCountries()
            message.success("Muvaffaqiyatli o'zgartirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'zgartirishda muammo yuzaga keldi!!!")
        })
    },
    createCountry: (v) => {
        axios.post('/countries', v).then(res => {
            get().getCountries()
            message.success("Muvaffaqiyatli qo'shildingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni qo'shishda muammo yuzaga keldi!!!")
        })
    }   
}))